<template>
  <div class="container">
    <poster :poster-list="posterList" :page-path="pagePath" :module-key="moduleKey" :token="token" :time-format="3" />
  </div>
</template>

<script>
import Poster from '../../../components/Poster/Index'

export default {
  name: "Double11MWPoster",
  components: {
    Poster
  },
  data() {
    return {
      token: this.$route.query.token,
      posterList: [
        {
          backgroundImage: 'http://freesaasofficedata.oss.aliyuncs.com/rolorweb/20221017174516330.png',
          tempBgImage: null,
          miniImage: 'http://freesaasofficedata.oss.aliyuncs.com/rolorweb/20221017174505444.png',
          textColor: '#ffffff',
          tempPoster: '',
          textPoint: [430, 1203],
          wxCode: { width: 190, point: [47, 1116] }
        },
        {
          backgroundImage: 'http://freesaasofficedata.oss.aliyuncs.com/rolorweb/20221017174543297.png',
          tempBgImage: null,
          miniImage: 'http://freesaasofficedata.oss.aliyuncs.com/rolorweb/20221017174530446.png',
          textColor: '#ffffff',
          tempPoster: '',
          textPoint: [430, 1203],
          wxCode: { width: 190, point: [47, 1116] }
        },
      ],
      pagePath: this.baseHost + '/',
      moduleKey: ''
    }
  },
  created() {
    this.moduleKey = this.token ? 'cb97de0e-6003-41b1-9c93-7b778dd67efb' : 'gzhMW20221111'
  }
}
</script>

<style scoped>
</style>